<div class="px-[2rem] py-[1rem]">
  <h1>{{ 'APP.ISABEL_REDIRECT.TITLE' | translate }}</h1>
</div>
